module.exports = __webpack_public_path__ + "static/netWorthIcon-49657d66c3838acc51796d00f822f5ee.png";